module.exports = __webpack_public_path__ + "static/media/google-scholar.07a38c13.svg";